/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBorderAll: {
  name: 'border-all';
  data: string;
} = {
  name: 'border-all',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 8v6h6v-6H5Zm6-2H5V5h6v6Zm2 2v6h6v-6h-6Zm6-2h-6V5h6v6Z" fill="currentColor"/></svg>`,
};
